<template>
  <card>
    <slot name="header">
      <h5 class="card-title text-danger font-weight-bold">
        Before the Course
      </h5>
    </slot>
    <div
      class="ml-2"
      style="line-height:1.6em;font-size:18px;"
    >
      <div>
        <router-link to="/participant/personal">
          <i :class="isCompleted(this.taskStatus.CompletedQuestionnaire)" />
          <span
            class="ml-2"
            style="vertical-align:-2px;"
          >Resource Questionnaire</span>
        </router-link>
      </div>
      <div>
        <router-link to="/participant/personal">
          <i :class="isCompleted(this.taskStatus.CompletedPicture)" />
          <span
            class="ml-2"
            style="vertical-align:-2px;"
          >Uploaded Photo</span>
        </router-link>
      </div>
      <div v-if="this.$root.courseScouterType === 'Participant'">
        <router-link to="/participant/precourse">
          <i :class="isCompleted(this.taskStatus.CompletedPreCourseAssignment)" />
          <span
            class="ml-2"
            style="vertical-align:-2px;"
          >Reflection Assignment</span>
        </router-link>
      </div>
      <div v-if="this.$root.courseScouterType === 'Staff'">
        <router-link to="/staff/personal">
          <i :class="isCompleted(this.taskStatus.CompletedBio)" />
          <span
            class="ml-2"
            style="vertical-align:-2px;"
          >Staff Bio</span>
        </router-link>
      </div>
      <div>
        <i :class="isCompleted(this.taskStatus.PaidInFull)" />
        <span
          class="ml-2"
          style="vertical-align:-2px;"
        >Course Dues Paid</span>
      </div>
      <div>
        <a
          href="https://filestore.scouting.org/filestore/HealthSafety/pdf/680-001_ABC.pdf"
          target="_blank"
        >
          <i class="bi bi-life-preserver" />
          <span
            class="ml-2"
            style="vertical-align:-2px;"
          >Medical Form -- A, B, C</span>
        </a>
      </div>
    </div>
  </card>
</template>

<script>
import taskApi from '@/services/api/task'

export default {
  name: 'HomeSharedTasks',
  data: function () {
    return {
      taskStatus: {},
      loading: true
    }
  },
  created: function () {
    this.$root.$on('course-change', data => {
      this.onCourseChange(data)
    })
  },
  mounted: function () {
    this.init()
  },
  methods: {
    init: function () {
      taskApi.getScouter(this.$root.courseKey, this.$root.scouterKey)
        .then(x => {
          this.taskStatus = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    isCompleted: function (value) {
      if (value) {
        return 'bi bi-check-square-fill'
      } else {
        return 'bi bi-square'
      }
    },
    onCourseChange: function (courseKey) {
      this.init()
    }
  }
}
</script>
